import { DropdownAvatar } from '@/components'
import { HamburgerIcon } from '@mote/assets/icons'
import { Block, Container, IconButton } from '@mote/ui'
import styled from '@xstyled/styled-components'
import { useAuth } from '../../auth/useAuth'
import { useDashboardContext } from './DashboardContextProvider'

export const DashboardHeader = ({ className, toggleSidebar, showToggler }) => {
  const dashboardContext = useDashboardContext()
  const auth = useAuth()
  const navbarTestId = auth.isAuthenticated
    ? 'authenticated-navbar'
    : 'unauthenticated-navbar'

  return (
    <Root data-testid={navbarTestId} className={className}>
      <ContentContainer>
        <StyledContent
          variant='wide'
          display='flex'
          alignItems='center'
          h='full'
          justifyContent={
            !dashboardContext.getShouldSidebarCollapse()
              ? 'flex-end'
              : 'space-between'
          }
        >
          {dashboardContext.getShouldSidebarCollapse() && (
            <IconButton
              onClick={dashboardContext.toggleSidebar}
              icon={<HamburgerIcon />}
              variant='ghost'
              pill={false}
            />
          )}
          <Block layout='horizontal' align='center' gap={8}>
            <DropdownAvatar />
          </Block>
        </StyledContent>
      </ContentContainer>
    </Root>
  )
}

const Root = styled.header`
  position: sticky;
  height: 88px;
  top: 0;
  z-index: 20;
  margin: 0 -40px;
  padding: 0 40px;
  background-color: white;

  @media (max-width: 920px) {
    margin: 0 -16px;
    padding: 0 16px;
  }
`

const ContentContainer = styled.div`
  padding: 0 8px;
  height: 100%;
`

const StyledContent = styled(Container)({
  padding: '0 !important'
})
